import { Module } from 'vuex';
import { NodeModelStoreModule, NodeModelStoreState } from '@/store/nodeModel';
import { LayerName } from '@etp/etp-pipelines-client/axios';
import { PipelinesStoreModule, PipelinesStoreState } from '@/store/pipelines';

const getDefaultState = () => {
  return {
    ...new NodeModelStoreModule('filtering').state,
    ...new PipelinesStoreModule(LayerName.FilteringLayer).state
  };
};

interface FilteringState extends NodeModelStoreState, PipelinesStoreState {}

const nodeModelStore = new NodeModelStoreModule('filtering');
const pipelinesStore = new PipelinesStoreModule(LayerName.FilteringLayer);

class FilteringModule implements Module<FilteringState, any> {
  namespaced = true;
  state = {
    ...nodeModelStore.state,
    ...pipelinesStore.state
  };
  getters = {
    ...nodeModelStore.getters,
    ...pipelinesStore.getters
  };
  actions = {
    ...nodeModelStore.actions,
    ...pipelinesStore.actions
  };
  mutations = {
    ...nodeModelStore.mutations,
    ...pipelinesStore.mutations,
    RESET_STATE(state: FilteringState) {
      Object.assign(state, getDefaultState());
    }
  };
}

export default new FilteringModule();
